<template>
    <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
    <!--
    <div class="col-md-12">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title">
                    <i class="fas fa-exclamation-triangle"></i>
                    Alerts
                </h3>
            </div>
            <div class="card-body">
                <div class="alert alert-danger alert-dismissible">
                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
                    <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                    Você possui
                </div>
            </div>
        </div>
    </div> -->

    <div class="row">
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon" style="background: rgb(26, 188, 156);"><i style="color:white"
                        class="fa fa-regular fa-file"></i></span>
                <!--
                <div class="info-box-content">
                    <span class="info-box-text">Restantes</span>
                    <span class="info-box-number">{{ cont_necessarios - cont_aprovados - cont_rejeitados -
                        cont_aguardando }}</span>
                </div>
                -->
                <div class="info-box-content">
                    <span class="info-box-text">Enviados</span>
                    <span class="info-box-number">{{ cont_enviados }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-success"><i style="color:white" class="fa fa-regular fa-file"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Aprovados</span>
                    <span class="info-box-number">{{ cont_aprovados }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-danger"><i class="fa fa-regular fa-file"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Rejeitados</span>
                    <span class="info-box-number">{{ cont_rejeitados }}</span>
                </div>
            </div>
        </div>
        <div class="col-md-3 col-sm-6 col-12">
            <div class="info-box">
                <span class="info-box-icon bg-info"><i class="fa fa-regular fa-file"></i></span>
                <div class="info-box-content">
                    <span class="info-box-text">Em análise</span>
                    <span class="info-box-number">{{ cont_aguardando }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

export default {

    props: ['cont_aguardando', 'cont_rejeitados', 'cont_aprovados', 'cont_necessarios', 'cont_enviados'],


    data() {
        return {
            isLoading: false,
            doc_tipo_usuario_selecionado: "",
            upload_files: "",
            aux_docs_tipo_usuario: []
        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

